import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white text-primary py-12" }
const _hoisted_2 = { class: "container mx-auto px-4" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" }
const _hoisted_4 = { class: "col-span-1 md:col-span-2 lg:col-span-1" }
const _hoisted_5 = { class: "flex space-x-4" }
const _hoisted_6 = {
  href: "https://www.facebook.com/coloniedesreves",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "text-primary hover:text-primary transition-colors"
}
const _hoisted_7 = {
  href: "https://www.instagram.com/coloniedesreves",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "text-primary hover:text-primary transition-colors"
}
const _hoisted_8 = { class: "space-y-2" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "mt-8 pt-8 border-t border-gray-700 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Facebook = _resolveComponent("Facebook")!
  const _component_Instagram = _resolveComponent("Instagram")!
  const _component_Phone = _resolveComponent("Phone")!
  const _component_Mail = _resolveComponent("Mail")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            src: "/logo.png",
            alt: "Colonie Des Rêves Logo",
            class: "h-12 mb-4"
          }, null, -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-sm mb-4" }, "Colonie Des Rêves provides memorable experiences for children, combining adventure, learning, and fun in a safe and stimulating environment.", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, [
              _createVNode(_component_Facebook, { class: "w-6 h-6" })
            ]),
            _createElementVNode("a", _hoisted_7, [
              _createVNode(_component_Instagram, { class: "w-6 h-6" })
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("a", {
              href: "https://www.tiktok.com/@coloniedesreves",
              target: "_blank",
              rel: "noopener noreferrer",
              class: "text-primary transition-colors"
            }, [
              _createElementVNode("svg", {
                class: "w-6 h-6",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M16.8217 5.1344C16.0886 4.29394 15.6479 3.19805 15.6479 2H14.7293M16.8217 5.1344C17.4898 5.90063 18.3944 6.45788 19.4245 6.67608C19.7446 6.74574 20.0786 6.78293 20.4266 6.78293V10.2191C18.645 10.2191 16.9932 9.64801 15.6477 8.68211V15.6707C15.6477 19.1627 12.8082 22 9.32386 22C7.50043 22 5.85334 21.2198 4.69806 19.98C3.64486 18.847 2.99994 17.3331 2.99994 15.6707C2.99994 12.2298 5.75592 9.42509 9.17073 9.35079M16.8217 5.1344C16.8039 5.12276 16.7861 5.11101 16.7684 5.09914M6.9855 17.3517C6.64217 16.8781 6.43802 16.2977 6.43802 15.6661C6.43802 14.0734 7.73249 12.7778 9.32394 12.7778C9.62087 12.7778 9.9085 12.8288 10.1776 12.9124V9.40192C9.89921 9.36473 9.61622 9.34149 9.32394 9.34149C9.27287 9.34149 8.86177 9.36884 8.81073 9.36884M14.7244 2H12.2097L12.2051 15.7775C12.1494 17.3192 10.8781 18.5591 9.32386 18.5591C8.35878 18.5591 7.50971 18.0808 6.98079 17.3564" })
              ])
            ], -1))
          ])
        ]),
        _cache[11] || (_cache[11] = _createStaticVNode("<div data-v-3ac25687><h3 class=\"text-lg font-semibold mb-4 text-primary\" data-v-3ac25687>Quick Links</h3><ul class=\"space-y-2\" data-v-3ac25687><li data-v-3ac25687><a href=\"#\" class=\"hover:text-primary transition-colors\" data-v-3ac25687>Home</a></li><li data-v-3ac25687><a href=\"/careers\" class=\"hover:text-primary transition-colors\" data-v-3ac25687>Careers</a></li><li data-v-3ac25687><a href=\"/#branches\" class=\"hover:text-primary transition-colors\" data-v-3ac25687>Branches</a></li><li data-v-3ac25687><a href=\"/registration\" class=\"hover:text-primary transition-colors\" data-v-3ac25687>Register</a></li><li data-v-3ac25687><a href=\"#contact\" class=\"hover:text-primary transition-colors\" data-v-3ac25687>Contact</a></li></ul></div>", 1)),
        _createElementVNode("div", null, [
          _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-lg font-semibold mb-4 text-primary" }, "Contact", -1)),
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_Phone, { class: "w-5 h-5 mr-2 text-primary" }),
              _cache[5] || (_cache[5] = _createElementVNode("a", {
                href: "tel:+96170498999",
                class: "hover:text-[#009FE3] transition-colors"
              }, "+961 70 498 999", -1))
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_Mail, { class: "w-5 h-5 mr-2 text-primary" }),
              _cache[6] || (_cache[6] = _createElementVNode("a", {
                href: "mailto:coloniedesreves@hnoudproduction.com",
                class: "hover:text-[#009FE3] transition-colors"
              }, "coloniedesreves@hnoudproduction.com", -1))
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-lg font-semibold mb-4 text-primary" }, "Stay Informed", -1)),
          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-sm mb-4" }, "Sign up for our newsletter to receive the latest news and special offers.", -1)),
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($setup.subscribeNewsletter && $setup.subscribeNewsletter(...args)), ["prevent"])),
            class: "flex border border-primary rounded-md w-fit"
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event)),
              placeholder: "Your email",
              class: "flex-grow px-4 py-2 rounded-l-md text-[#1D1D1B]",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.email]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("button", {
              type: "submit",
              class: "bg-primary hover:bg-primary/80 px-4 py-2 rounded-r-md text-white transition-colors"
            }, " Subscribe ", -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", null, "© " + _toDisplayString(new Date().getFullYear()) + " Colonie Des Rêves. All rights reserved.", 1)
      ])
    ])
  ]))
}